import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AdminContent from '../../components/AdminContent';
import NonEditablePages from './components/NonEditablePages';

export const pageAdminInfo = {
  title: 'Páginas',
  description: 'Personalize configurações gerais das páginas',
  path: 'pages',
};

const CmsPagesPage: FC = () => {
  const { t } = useTranslation();
  return (
    <AdminContent
      title={t('adminPageTitle')}
      description={t('adminPageDescription')}
    >
      <NonEditablePages />
    </AdminContent>
  );
};
export default CmsPagesPage;
